import Swiper, { Pagination, Navigation } from 'swiper';

import '../layouts/default';

import '../ui/slider';
import '../ui/tabs';

Swiper.use([Pagination, Navigation]);
